import * as THREE from 'three';
import {ThumbnailFile} from '@/types/productV2';

/*
export type FilePreview = {

    data: File;
    string: string; // dataURL
    name: string;
    size: number;
    type: string;
    url?: string;
    fileExtension?: string | null;

};
*/


export default async function getThumbnail(filename = 'thumbnail.png'): Promise<ThumbnailFile> {

    const {composer} = (window as any).threeViewer;
    const {renderer} = composer;



    const srcCanvas = renderer.domElement as HTMLCanvasElement;
    const attr = renderer.getContext().getContextAttributes();
    const W = srcCanvas.width, H = srcCanvas.height, S = Math.min(W, H);
    const sx = (W - S) >> 1, sy = (H - S) >> 1;


    const out = document.createElement('canvas');

    out.width = S;
    out.height = S;



    const ctx = out.getContext('2d');
    if (!ctx) throw new Error('2D context not available');


    ctx.drawImage(srcCanvas, sx, sy, S, S, 0, 0, S, S);


    if (attr?.preserveDrawingBuffer) {
        console.log(1)
        composer.render();
        ctx.drawImage(srcCanvas, sx, sy, S, S, 0, 0, S, S);

    } else {

    // robust path: read from composer's readBuffer

        composer.render();

        const rt = composer.readBuffer as THREE.WebGLRenderTarget;

        const pixels = new Uint8Array(S * S * 4);

        renderer.readRenderTargetPixels(rt, sx, sy, S, S, pixels);

        const row = S * 4;

        const flipped = new Uint8ClampedArray(pixels.length);

        for (let y = 0; y < S; y++) {

            const src = (S - 1 - y) * row;

            flipped.set(pixels.subarray(src, src + row), y * row);

        }

        ctx.putImageData(new ImageData(flipped, S, S), 0, 0);
        ctx.drawImage(srcCanvas, sx, sy, S, S, 0, 0, S, S);

    }


    const blob: Blob = await new Promise((res) => {
        //out.width = 400;
        //out.height = 400;
        out.toBlob(b => res(b as Blob), 'image/png')
    });

    const file = new File([blob], filename, {type: 'image/png'});

    //const url = await URL.createObjectURL(blob);


// dataURL if you still need string

    const string = await new Promise<string>((res) => {

        const r = new FileReader();

        r.onload = () => res(r.result as string);

        r.readAsDataURL(blob);

    });


    return {

        data: file,
        string,
        name: filename,
        size: file.size,
        type: file.type,
        url: "",
        fileExtension: 'png'

    };

}